import { TableProps } from "./types"

type TableColumnsProps = Pick<TableProps, "header">

export function TableColumns({ header }: TableColumnsProps) {
  return header.row.cells.map((c, i) => {
    if (i === header.row.cells.length - 1) {
      return <col key={c.key} />
    }
    return <col key={c.key} style={{ width: c.width }} />
  })
}
